module.exports = __webpack_public_path__ + "img/ttdz-btn.81dd1aa6.png";